import React, { Component } from 'react';

import Button from '../ui/Button'
import Popup from 'reactjs-popup';
import PopupHeader from '../ui/PopupHeader'

import ModernFileUploader from '../ui/ModernFileUploader';
import { doc, updateDoc } from 'firebase/firestore';

import SpinnerPanel from '../ui/SpinnerPanel';

import { sendBadge, sendImmediateNudgesFunction } from '../util/FunctionUtils';

import 'reactjs-popup/dist/index.css';
import moment from 'moment';

import { activityTeamChallengeHabitCheck } from '../activity/ActivityUtils';
import { challengeStatsUpdate, calculateCurrentStreak, calculateDaysDoneBeforeDate } from '../util/StatsUtils';

import { getCheckinsForUser, serialiseCheckins } from '../util/TeamChallengeUtils';


// import CheckinConfirmationPopup from './CheckinConfirmationPopup';

const calendarDateFormat = 'YYYY-MM-DD';
const calendarDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';

const journalPrompts = [
  "Do you have any thoughts to share?",
  "What did you learn?",
  "How did you feel after?",
  "Is the habit becoming easier?",
  "Did you have any challenges?",
  "Are you finding the habit easy or difficult?",
  "Are you finding the habit useful?",
  "Are you finding the habit worthwhile?",
  "Is the habit becoming more ingrained?",
  "Is the habit becoming more natural?",
  "Is the habit becoming more routine?",
  "Is the habit becoming more second nature?",
  "Is the habit becoming more straightforward?",
  "Are there any obstacles?",
  "Do you notice any patterns?",
  "Would you recommend the habit to others?",
  "Do you have any advice about this habit?",
  "How can you make the habit more enjoyable?",
  "How can you make the habit more rewarding?",
  "How can you make the habit more satisfying?",
  "How can you make the habit more fun?",
  "How can you make the habit more interesting?",
  "How can you make the habit more motivating?",
  "What value have you got from practicing this habit?",
  "What value does this habit bring to your work?",
  "Can you scale the habit?",
  "Can you combine this habit with others?",
]

class TeamChallengeHabitPopup extends Component {

  constructor(props) {
      super(props);
      this.state = { journal : "", 
                     displayCheckinConfirmation : false,
                     displayImageUploader : false,
                     images : [],
                     fileToUpload : null,
                     postingUpdate: false,
                     uploadingFile : false,
                     uploadPercentage: 0,
                     placeholderText: "How did it go? " + this.getRandomPrompt() };
  } 

  //create ref
  fileInputRef = React.createRef();  

  componentWillMount = () => {

  }

  handleJournalChange = (event) => {
    this.setState({ journal: event.target.value });
  }


  habitUpdate = (done) => {
    if (this.state.postingUpdate)
      return

    this.setState({ postingUpdate : true })

    var checkins = getCheckinsForUser(this.props.team['team-challenges'][this.props.challengeId], this.props.firebase.user.uid);

    if (!checkins[this.props.habitId])
      checkins[this.props.habitId] = 1
    else
      checkins[this.props.habitId] = checkins[this.props.habitId] + 1

    const checkinsString = serialiseCheckins(checkins)

    var update = {};
    update['team-challenges.' + this.props.challengeId + ".checkins." + this.props.firebase.user.uid] = checkinsString

    updateDoc(doc(this.props.firebase.firestore, 'teams', this.props.teamId), update)
    .then(() => {
    // alert("Successfully updated checkins")
        this.setState({ postingUpdate : false })

        this.props.onClose(true, true);

    })
    .catch((error) => {
      this.setState({ postingUpdate : false })
    
      alert(error);
    });

    const currentDate = moment(this.props.date).format(calendarDateFormat);

    activityTeamChallengeHabitCheck(this.props.firebase, this.props.firebase.user.uid, this.props.teamId, this.props.challengeId, currentDate, this.props.habitId, this.state.journal, this.state.images) 
  }

  getRandomPrompt = () => {
    return journalPrompts[Math.floor(Math.random() * journalPrompts.length)];
  }

  habitClicked = () => {
    if (this.props.habitClicked)
      this.props.habitClicked();
  }

  fileChange = (event) => {
    this.setState({ fileToUpload : event.target.files[0], uploadingFile: true })
  }

  handleUploadStart = () => {
    this.setState({ uploadingFile: true, uploadPercentage: 0 })
  }

  handleUploadSuccess = (file) => {
    const fullUrl = "https://firebasestorage.googleapis.com/v0/b/lasoo-d9fad.appspot.com/o/images%2F" + file + "?alt=media";

    var images = this.state.images
    images.push(fullUrl)

    this.setState({ uploadingFile: false, images: images, uploadPercentage: 0 })
  }

  handleUploadError = (e) => {
    this.setState({ uploadingFile: false })
  }

  handleUploadProgress = (percentage) => {
    this.setState( { uploadPercentage : percentage })
  }

  getProgressBarWidth = () => {
    return this.state.uploadPercentage * 280.0 / 100.0
  }

  renderImages = () => {
    var images = []
    for (var i = 0; i < Math.min(this.state.images.length, 5); i++) {
      images.push(<img width="35" height="35" className='habitPopupImageUploaderImage' src={this.state.images[i]} alt=''/>)
    }

    return <div className='habitPopupImageUploaderImageContainer'>{images}</div>
  }

  renderChallengeUpdate = () => {
    var challenge = this.props.challenge;

    const disabled = !this.props.journalOptional && (this.state.journal === '' || this.state.postingUpdate)

    return <Popup open="true" closeOnDocumentClick className='habit-popup-with-image-uploader' onClose={this.props.onClose}>
        <PopupHeader title={this.props.habitName}/>
        <div width="100%" height="100%">

          { this.state.postingUpdate && <div className='teamChallengeHabitPopupSpinner'><SpinnerPanel/></div> }
          
          { !this.state.postingUpdate && 
            <div>
              <textarea className="habitPopupHabitJournal" placeholder={this.state.placeholderText} id="journal" name="journal" onChange={ (event) => { this.handleJournalChange(event); }} value={this.state.journal}></textarea>

              <div className='habitPopupImageUploaderContainer' onClick={this.showImageUploader}>
                { this.renderImages() }
                <div className='habitPopupImageUploader'>
                    <label className='habitPopupImageUploaderIcon'>
                        <img src="/icons/camera.png" width={30} height={30} alt="" />
                        <ModernFileUploader
                          accept="image/*"
                          name="image"
                          hidden
                          multiple
                          randomizeFilename
                          storage={this.props.firebase.storage}
                          path="images"
                          onUploadStart={this.handleUploadStart}
                          onUploadError={this.handleUploadError}
                          onUploadSuccess={this.handleUploadSuccess}
                          onProgress={this.handleUploadProgress}
                        />
                    </label>     
                </div>
              </div>
       

            {  this.state.uploadingFile ?
              <div className='habitPopupImageUploaderProgressContainer'>
                  <div className='habitPopupImageUploaderProgressBarBackground'/>
                  <div className='habitPopupImageUploaderProgressBar' style={{ width: this.getProgressBarWidth() + 'px' }}/>
              </div>
            :

            <div>
              <div className='teamChallengeHabitPopupDoneButton'>
                <Button size='large' disabled={disabled} type={disabled ? 'secondary' : 'primary'} onClick={() => this.habitUpdate(true)} action='Completed'/>
              </div>  
            </div>
            }


             </div>
          }
            
        </div>
    </Popup>
  }


  render = () => {
    /*
    if (this.state.displayCheckinConfirmation)
      return this.renderCheckinConfirmation()
    else */

      return this.renderChallengeUpdate()
  }
};

export default TeamChallengeHabitPopup;
